import React, { memo, useEffect, useRef, useState } from "react";

const OptionTag = memo(({ value, label, orderIds, onClick, isSelected, staggerMs = 0 }) => {
  const prevSelectedRef = useRef(false);
  const [justSelected, setJustSelected] = useState(false);

  useEffect(() => {
    if (isSelected && !prevSelectedRef.current) {
      setJustSelected(true);
      const t = window.setTimeout(() => setJustSelected(false), 520);
      prevSelectedRef.current = true;
      return () => window.clearTimeout(t);
    }
    if (!isSelected) {
      prevSelectedRef.current = false;
    }
  }, [isSelected]);

  const staggerStyle = { "--vh-stagger": `${staggerMs}ms` };

  return (
    <button
      type="button"
      className={`services-picker__tag description-n vh-assessment__option-tag ${
        isSelected ? "services-picker__tag--active" : ""
      } ${justSelected ? "vh-assessment__option-tag--picked" : ""}`}
      style={staggerStyle}
      data-value={value}
      {...(orderIds ? { "data-orders-ids": orderIds } : {})}
      aria-pressed={isSelected}
      {...(onClick ? { onClick } : {})}
    >
      {isSelected ? (
        <span className="vh-assessment__option-tag-check" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.5 7.2L5.8 10.5L11.5 3.5"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      ) : null}
      <span className="vh-assessment__option-tag-label">{label}</span>
    </button>
  );
});

OptionTag.displayName = "OptionTag";

export default OptionTag;
